import { render, staticRenderFns } from "./EventShow.vue?vue&type=template&id=5154079b&scoped=true&"
import script from "./EventShow.vue?vue&type=script&lang=js&"
export * from "./EventShow.vue?vue&type=script&lang=js&"
import style0 from "./EventShow.vue?vue&type=style&index=0&id=5154079b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154079b",
  null
  
)

export default component.exports